import {CommonResponse, BaseRequestParams, GetParamsType, GetSingleParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {CompanyResponse, UserGroupResponse, UserGroupsResponse} from "../models/response"

export const userGroupApi = {
    getUserGroups(params?: GetParamsType & UserGroupsFilterQuery): Promise<CommonResponse<UserGroupsResponse>> {
        const paramsString = filterToString(params)
        return instance.get(`UserGroup${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    getUserGroup(params: GetSingleParamsType): Promise<CommonResponse<UserGroupResponse>> {
        const {id, controller} = params
        return instance.get(`UserGroup/${id}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    createUserGroup(form: CreateUserGroupType): Promise<CommonResponse<UserGroupResponse>> {
        const {controller, ...rest} = form
        return instance.post(`UserGroup`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    changeUserGroup(form: ChangeUserGroupType): Promise<CommonResponse<UserGroupResponse>> {
        const {id, controller, ...rest} = form
        return instance.put(`UserGroup/${id}`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    deleteUserGroup(id: number): Promise<CommonResponse<boolean>> {
        return instance.delete(`UserGroup/${id}`).then((res: AxiosResponse) => res.data)
    },
}

export type UserGroupsFilterQuery = {
    idCompany?: number
    search?: string
}

export type CreateUserGroupType = {
    name: string
    idCompany: number
    active: boolean
} & BaseRequestParams

export type ChangeUserGroupType = {
    id: number
} & CreateUserGroupType